import {z} from 'zod';

export const AttributeVocabularySchema = z.object({
	count: z.number().positive().int(),
	id: z.number().positive(),
	modDate: z.date(),
	name: z.string().nonempty(),
});

export default AttributeVocabularySchema;

export const AttributeVocabularyField = AttributeVocabularySchema.keyof().enum;

export type IAttributeVocabulary = z.infer<typeof AttributeVocabularySchema>;

export const AttributeVocabularySchemaNew = AttributeVocabularySchema.pick({
	name: true,
	id: true,
});

/** a new attribute vocabulary record */
export type IAttributeVocabularyNew = z.infer<
	typeof AttributeVocabularySchemaNew
>;

/** vocabulary form values schema */
export const AttributeVocabularyFormSchema = AttributeVocabularySchema.pick({
	name: true,
});

export type IAttributeVocabularyFormValues = z.infer<
	typeof AttributeVocabularyFormSchema
>;

export const AttributeVocabularyReplaceWarningObjectSchema = z.object({
	vocabId: z.number().positive(),
	vocabName: z.string().nonempty(),
	addedItemCount: z.number().int().nonnegative(),
	updatedItemCount: z.number().int().nonnegative(),
	deletedItemCount: z.number().int().nonnegative(),
	ignoredItemCount: z.number().int().nonnegative(),
	ignoreItemIndices: z.array(z.number().int().nonnegative()),
});

export type IAttributeVocabularyReplaceWarningObject = z.infer<
	typeof AttributeVocabularyReplaceWarningObjectSchema
>;

export const AttributeVocabularyReplaceWarningObjectField =
	AttributeVocabularyReplaceWarningObjectSchema.keyof().enum;
